export default __webpack_public_path__ + "static/media/390.1beac7f8.png";